// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","511":"cart"}[chunkId] + "." + {"177":"c1efc64a","511":"90efde57"}[chunkId] + ".css";
};